import { gql } from 'graphql-request';

export const UPDATE_POA_DRAFT = gql`
  mutation CorePOAUpdateDraft($input: core_POAMutationNS_updateDraftInputInput) {
    corePOA {
      updateDraft(input: $input)
    }
  }
`;
